import { Link } from "react-router-dom";
import { COLORS } from "../hooks/useAudioRecorder";

/**
 * Universal footer with privacy/FAQ links. Drop into every page so
 * positioning + legal links are always reachable. The links are styled
 * to match the surrounding mono+faint text but get slightly brighter on
 * hover so they're discoverable without competing visually.
 */
export default function AppFooter({ position = "static" }) {
  return (
    <footer
      data-testid="app-footer"
      style={{
        ...(position === "absolute"
          ? {
              position: "absolute",
              bottom: 14,
              left: 18,
              right: 18,
            }
          : {
              marginTop: 24,
            }),
        borderTop: "1px dashed #2a2721",
        paddingTop: 14,
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontSize: 10,
        color: COLORS.faint,
        letterSpacing: "0.06em",
        textAlign: "center",
        lineHeight: 1.6,
      }}
    >
      <span>// HandInvoice · for independent professionals · </span>
      <FooterLink to="/privacy">privacy</FooterLink>
      <span> · </span>
      <FooterLink to="/faq">faq</FooterLink>
    </footer>
  );
}

const FooterLink = ({ to, children }) => (
  <Link
    to={to}
    style={{
      color: COLORS.faint,
      textDecoration: "none",
      transition: "color 160ms ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = COLORS.text)}
    onMouseLeave={(e) => (e.currentTarget.style.color = COLORS.faint)}
  >
    {children}
  </Link>
);
